import { combineTokens, makeSelectors, css, makeScaleableToken } from '@utils/css';

const sliderModifiers = makeSelectors({
  disableTransition: "dibd100dzy3"
});
const sliderTokens = combineTokens("--css-slider", {
  itemsPerPage: "3",
  itemMargin: "3rem",
  containerPadding: ["0rem", makeScaleableToken],
  transitionDurationBase: "0.45s",
  transitionDurationExtraPerItem: "0.1s"
});
const disallowOverflowModifier = css`
  overflow: hidden;
  content-visibility: auto;
`;
const wrapper = "dibw1kxw1ow";
const slider = "dibs1cp680u";
const spacer = "dibs1low5mx";

export { disallowOverflowModifier, slider, sliderModifiers, sliderTokens, spacer, wrapper };
import "./slider.styles.linaria.module.css";
//# sourceMappingURL=slider.styles.js.map
